import React from 'react';
import { motion } from 'framer-motion';
import { RequestDemoButton } from 'components';
import { animationParams, animationVariants } from 'fragments';
import { landingImages } from 'assets';

export const ReadyTransform = ({
    className,
    title = 'Ready to Transform Your ABA Practice?',
    description = 'Join a group of the most advanced clinics across the United States that are using Therapylake to streamline operations, improve clinical outcomes and grow their practice. Start your free trial today!',
    info = 'No credit card required • 2 months free trial • Cancel anytime',
}) => {
    return (
        <div className={`ready-transform-wrapper ${className ? className : ''}`}>
            <div className="ready-transform-beck-svg">
                <img src={landingImages.vectorImg} alt="vector" style={{ width: '100%', height: '100%' }} />
            </div>

            <div className="ready-transform-block">
                <div className="container">
                    <div className="ready-transform-box">
                        <div style={{ overflow: 'hidden' }}>
                            <motion.h2 className="ready-transform-title" {...animationParams} variants={animationVariants.titleVariant}>
                                {title}
                            </motion.h2>
                        </div>

                        <div style={{ overflow: 'hidden' }}>
                            <p className="ready-transform-description">
                                {description}
                            </p>
                        </div>

                        <div className="ready-transform-btns-block">
                            <RequestDemoButton
                                className="ready-transform-request-btn"
                                arrowIcon
                            />
                        </div>

                        <p className="ready-transform-info">
                            {info}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
